import * as R from 'ramda';
import { Asset } from '../asset';
import { AssetProviderUid } from '../asset-provider-uid.enum';
import { AssetsCollection } from '../assets-collection';
import { DesignStructure } from '../design-structure';
import { getUsedAssetIds } from '@gelato-api-ui/core/designs/helpers/getUsedAssetIds';

export const getUsedAssets = (
  assetsCollection: AssetsCollection,
  designStructure: DesignStructure,
  assetProviderUids: AssetProviderUid[] = null,
): Asset[] => {
  if (!designStructure || !designStructure.spreads || !designStructure.spreads.length) {
    return [];
  }

  const assetsArray: Asset[] = R.values(assetsCollection);
  const usedAssetIds = getUsedAssetIds(designStructure);
  const usedAssets: Asset[] = usedAssetIds
    .map(loopAssetId => {
      const foundAsset = (assetsArray || []).find(loopAsset => loopAsset?.id === loopAssetId);

      return R.omit(['uppyId'], foundAsset);
    })
    .filter(Boolean)
    .filter(loopAsset => !assetProviderUids?.length || assetProviderUids.includes(loopAsset.assetProviderUid));

  return R.uniq(usedAssets);
};
